import React from 'react';
import PropTypes from 'prop-types';
import Messages from '../../constants/Messages';

const SalesCard = (props) => {
    const {
        label, 
        value
    } = props;

    return (
        <div className="grow mr-2 rounded-lg overflow-hidden p-4 bg-blue-300 text-center">
            <div className='text-sm'>{label}</div>
            <div className='text-2xl'><span className='text-lg'>{Messages.CURRENCY.INR}</span> {value}</div>
        </div>
    )
}

SalesCard.propTypes = {
    label : PropTypes.string,
    value : PropTypes.number
};

export default SalesCard;





